



















import Vue from 'vue'
import AppNotificationsItem from './AppNotificationsItem.vue'

export default Vue.extend({
  name: 'AppNotifications',
  components: {
    AppNotificationsItem
  },
  computed: {
    notifications () {
      return this.$store.getters['global/notifications']
    }
  }
})
